"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var prismjs_1 = __importDefault(require("prismjs"));
var react_1 = __importDefault(require("react"));
require("prismjs/themes/prism-okaidia.css");
require("prismjs/plugins/toolbar/prism-toolbar");
require("prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var CodeHighlight_1 = __importDefault(require("./styles/CodeHighlight"));
var CodePreviewWrapper_1 = __importDefault(require("./styles/CodePreviewWrapper"));
var DescriptionWrapper_1 = __importDefault(require("./styles/DescriptionWrapper"));
var DesignSystemTemplate = function (_a) {
    var heading = _a.heading, description = _a.description, renderPreview = _a.renderPreview, renderCode = _a.renderCode, previewStackProps = _a.previewStackProps, vertical = _a.vertical;
    react_1.default.useEffect(function () {
        prismjs_1.default.highlightAll();
    });
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ p: 2 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: heading })), description && (0, jsx_runtime_1.jsx)(DescriptionWrapper_1.default, { children: description }), (0, jsx_runtime_1.jsx)(CodePreviewWrapper_1.default, { children: (0, jsx_runtime_1.jsx)(Stack_1.default, __assign({ direction: vertical ? 'column' : 'row', spacing: 2, justifyContent: "center", alignItems: "center" }, previewStackProps, { children: renderPreview })) }), (0, jsx_runtime_1.jsx)(CodeHighlight_1.default, { children: (0, jsx_runtime_1.jsxs)("pre", { children: [(0, jsx_runtime_1.jsx)("code", __assign({ className: "language-html" }, { children: renderCode })), (0, jsx_runtime_1.jsx)("button", { className: "copy-to-clipboard-button", type: "button", "data-copy-state": "copy" })] }) })] })));
};
exports.default = DesignSystemTemplate;
